module.exports = __webpack_public_path__ + "img/pos2cropped.45e5a8a2.webp";